import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getPageTemplates(websiteId, params = {}) {
  return axios.get(`/ajax/websites/${websiteId}/page_templates`, { params })
}

export function getPageTemplate(id) {
  return axios.get(`/ajax/page_templates/${id}`)
}

export function createPageTemplate(websiteId, data) {
  return axios.post(`/ajax/websites/${websiteId}/page_templates`, data)
}

export function updatePageTemplate(id, data) {
  return axios.patch(`/ajax/page_templates/${id}`, data)
}

export function destroyPageTemplate(id) {
  return axios.delete(`/ajax/page_templates/${id}`)
}
